import { put, call, select } from 'redux-saga/effects'
import { RTM_ORDER_MESSAGE, RTM_NOTIFY_CENTER_MESSAGE } from '../socket/actionTypes'
import { FETCH_MESSAGES, SEND_MESSAGE, PLAY_ACTION_AUDIO } from './actionTypes'
import { getOrder } from '../orders/services'
import { fetchMessages, sendMessage } from './services'
import { getOrderSuccess } from '../orders/actions'
import { findById as getOrderById, activeOrderId } from '../orders/selectors'
import * as actions from './actions'

const isManagerMode = process.env.APP_MODE === 'manager';

export default {
  *[RTM_ORDER_MESSAGE]({ payload }) {

    const { order_id } = payload
    let order = yield select(getOrderById, order_id)
    if (!order) {
      // 当前系统没有order的话不应该处理
      return
    }
    // yield put(actions.receiveMessage(payload))
    yield put(actions.fetchMessages({
      orderId: order_id,
      earlier_at: Date.now(),
    }))
  },

  *[FETCH_MESSAGES]({ payload }) {
    const result = yield call(fetchMessages, {
      ...payload,
      earlier_at: typeof payload.earlier_at === 'number' ? payload.earlier_at + 600 : payload.earlier_at
    })
    yield put(actions.messagesFetched(result))
  },

  *[SEND_MESSAGE]({ payload }) {
    yield call(sendMessage, payload)
  },

  *[PLAY_ACTION_AUDIO]() {
    // if (isManagerMode) return false
    // var audio = new Audio();
    // audio.src = process.env.PUBLIC_URL + '/action.mp3';
    // audio.play();
    // audio.addEventListener('ended', () => {
    //   audio.remove();
    // });
  },
}
